import { VueModule } from '@Foundation/utilities';
import contrastSwitcherButton from './code/Scripts/components/contrastSwitcherButton';

export default VueModule({
  components: {
    contrastSwitcherButton
  }
});
